import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAcrissGroups, useAcrissGroupsValidator } from "Pages/OneWay/AcrissGroups/@hooks"
import { acrissGroupFormData } from "Pages/OneWay/AcrissGroups/@signals"


export default function AcrissGroupDrawerName() {
	const { handleChangeFormData } = useAcrissGroups()
	const { nameError } = useAcrissGroupsValidator()

	return <TextFieldSeeker
		error={nameError}
		placeholder="Group name"
		value={acrissGroupFormData.value?.name || ''}
		onChange={e => handleChangeFormData(e.target.value, 'name')}
	/>
}
